import { SEARCH_URL } from '@/constants';

/**
 * Class definition for `wp-search` element
 *
 * @class WPSearch
 * @extends {HTMLElement}
 */
class WPSearch extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._form = this.querySelector('form');
    this._input = this.querySelector('input');
    this._searchResults = document.querySelector('wp-search-results');
    return self;
  }

  /**
   * Tag name of element
   *
   * @readonly
   * @static
   */
  static get is() {
    return 'wp-search';
  }

  /**
   * Getter for `filled` attribute
   */
  get filled() {
    return this.hasAttribute('filled');
  }

  /**
   * Setter for `filled` attribute
   */
  set filled(value) {
    if (Boolean(value)) {
      this.setAttribute('filled', '');
    } else {
      this.removeAttribute('filled');
    }
  }

  connectedCallback() {
    // If no search input found, return
    if (!this._form && !this._input) {
      console.warn('No search form and input found');
      return;
    }

    this._bindHandlers();
    this._addEventListeners();
  }

  disconnectedCallback() {
    this._searchResults.removeEventListener(
      'searchresultsupdated',
      this._handleSearchResultsUpdate,
    );
  }

  _bindHandlers() {
    this._handleSearchResultsUpdate =
      this._handleSearchResultsUpdate.bind(this);
  }

  _addEventListeners() {
    this._form.addEventListener(
      'submit',
      this._handleSearchSubmit.bind(this),
      false,
    );
    this._input.addEventListener(
      'blur',
      () => {
        window.removeEventListener('keyup', this._handleKeyUp, false);
      },
      false,
    );
    this._searchResults.addEventListener(
      'searchresultsupdated',
      this._handleSearchResultsUpdate,
    );
    window.addEventListener('keyup', this._handleKeyUp.bind(this), false);
  }

  _handleSearchSubmit(evt) {
    evt.preventDefault();
    this._searchResults.query = this._input.value;
    this._searchResults.returnTarget = evt.target;
  }

  _handleKeyUp() {
    if (this.contains(document.activeElement)) {
      if (this._input.value !== '') {
        this.filled = true;
      } else {
        this.filled = false;
      }
    }
  }

  _handleSearchResultsUpdate(evt) {
    this._input.value = evt.detail.query;
  }
}

customElements.define(WPSearch.is, WPSearch);
